import { setTableSize } from '../../state/internal/actions';
import { defineTransaction } from '../common/transactions';
import { SET_TABLE_SIZE, type SetTableSizeAction } from './action';

export default defineTransaction(SET_TABLE_SIZE, (action: SetTableSizeAction) =>
	setTableSize(action.payload),
);
